import React from 'react';
import { Route } from 'react-router-dom';
import { ForbiddenPage } from '../../pages/ErrorPages/index';

const CustomRoute = ({ perm, ...props }) => {
  const permEval =
    typeof perm === 'object'
      ? Object.values(perm).some((value) => value === true)
      : perm;
  if (permEval) {
    return <Route {...props} />;
  }
  return (
    <Route
      {...props}
      render={(props) => {
        return <ForbiddenPage {...props} />;
      }}
    />
  );
};

export default CustomRoute;
